module.exports = __webpack_public_path__ + "static/media/pubg2.a60e988a.jpg";